<template>
  <div>
    <div class="company-card">
      <div
        class="row"
        @click="$router.push({ path: '/jobs/admin/company/' + company.id })"
      >
        <div class="col-12 col-md-8">
          <div class="row mb-3 mb-sm-0">
            <div class="col-12 col-sm-2">
              <img
                class="company-avatar"
                :src="basepath + 'uploads/avatars/' + company.avatar.filename"
              >
            </div>
            <div class="col-12 col-sm-10 m-auto">
              <h1 class="title">
                {{ company.first_name }} {{ company.last_name }}
              </h1>
              <h1 class="contact">
                {{ company.email }}
              </h1>
              <h1
                v-if="company.city && company.country"
                class="municipality"
              >
                {{ company.city }}, {{ company.country }}
              </h1>
              <div class="sm-text">
                <font-awesome-icon
                  icon="clock"
                />
                {{ company.created_at }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 my-auto">
          <h1 class="company-title">
            {{ company.company.title }}
          </h1>
          <h1 class="title">
            <span style="font-size: 0.9rem">{{ $t('generic.cif', 'CIF') }}:</span>
            {{ company.company.number }}
          </h1>
          <h1 class="contact">
            <font-awesome-icon
              icon="phone-square"
            />
            <span style="font-size: 0.9rem; color: #777">{{ $t('cards.one-company.phone', 'Phone') }}:</span>
            {{ company.company.phone }}
          </h1>
          <h1 class="status">
            {{ $t('cards.one-company.status', 'Status') }}:
            <span :class="companyStatus.toLowerCase()">
              {{ companyStatus }}
            </span>
          </h1>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    company: {
      type: Object,
      default: null
    }
  },
  computed: {
    companyStatus() {
      if (this.company.company.isVerified == true) {
        if (this.company.company.status === 'active') {
          return this.$t('cards.one-company.status.confirmed', 'Confirmed');
        }
      } else {
        if (this.company.company.status === 'pending') {
          return this.$t('cards.one-company.status.pending', 'Pending');
        } else if (this.company.company.status === 'rejected') {
          return this.$t('cards.one-company.status.rejected', 'Rejected');
        }
      }
      return this.$t('cards.one-company.status.pending', 'Pending');
    },
    basepath() {
      return process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH;
    }
  }
}
</script>

<style lang="scss" scoped>
  .company-card {
    cursor: pointer;
    background: white;
    padding: 10px 25px;
    margin-bottom: 1rem;
    transition: 0.3s ease;

    &:hover {
      box-shadow: 3px 3px 20px 0px rgba(210,210,210,1);
    }
  }

  h1.title {
    color: #999;
    font-size: 1rem !important;
    margin-bottom: 0;
  }

  h1.company-title {
    color: #009090;
    font-size: 0.9rem !important;
    text-transform: uppercase;
    margin-bottom: 0;
  }

  h1.municipality {
    color: #777;
    font-size: 0.8rem !important;
    margin-bottom: 0;
  }

  h1.contact {
    color: rgb(80, 80, 80);
    font-size: 1rem !important;
    margin-bottom: 0;
  }

  h1.status {
    color: #777;
    font-size: 1rem !important;

    span.confirmed {
      color: #28a745;
    }

    span.pending {
      color: #ffc107;
    }

    span.rejected {
      color: #dc3545;
    }
  }

  .sm-text {
    font-size: 0.9rem;
    color: #666;
  }

  .company-avatar {
    width: 75px;
    height: 75px;
    border-radius: 50%;
    box-shadow: 2px 3px 15px 10px rgba(0, 0, 0, 0.1), -1px 0 2px 0px rgba(0, 0, 0, 0.05);
  }
</style>
